// src/index.js
import "./firebase";  
import React from 'react';
import ReactDOM from 'react-dom/client'; // React 18's new API
import './index.css'; // Your custom CSS
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS

// Load Stripe with your publishable key


// Get the root element
const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
        <App />
     
    </React.StrictMode>
  );
} else {
  console.error("Root container is missing in index.html.");
}

reportWebVitals();
